import { Component, Input } from '@angular/core';

@Component({
  selector: 'boma-unauthed',
  templateUrl: './unauthed.component.html',
  styleUrls: ['./unauthed.component.scss'],
})
export class UnauthedComponent {
  @Input() minimal: boolean = false;
}
